<app-smooth-height [trigger]="articles">
  <app-page-loader [loader]="findMarketingArticles" style="overflow: hidden">
    <ng-container *ngFor="let a of articles">
      <app-marketing-article-item [data]="a"></app-marketing-article-item>
    </ng-container>
  </app-page-loader>
</app-smooth-height>
